import { useEffect, useState } from 'react';

const Marker: React.FC<
  google.maps.MarkerOptions & {
    onClick?: (e: google.maps.MapMouseEvent) => void;
  }
> = (options) => {
  const [marker, setMarker] = useState<google.maps.Marker>();

  useEffect(() => {
    if (!marker) {
      const auxMarker = new google.maps.Marker();
      setMarker(auxMarker);
    }

    // remove marker from map on unmount
    return () => {
      if (marker) {
        marker.setMap(null);
      }
    };
  }, [marker]);

  useEffect(() => {
    if (marker) {
      if (options.onClick) {
        marker.addListener('click', options.onClick);
      }
      marker.setOptions(options);
    }
  }, [marker, options]);

  return null;
};

export default Marker;
